import { useSelectedCoreLocationId, useSelectedLocation } from '@elva/platform';

/** core-api-az numeric location id, for legacy product endpoints. */
export function useLocationId(): number | undefined {
  return useSelectedCoreLocationId();
}

/** Account-service location UUID — session scoping and location switch. */
export function useLocationUuid(): string | undefined {
  return useSelectedLocation()?.id;
}

/** Practice-management tenant key, for services that file data under it. */
export function useLocationAscendId(): string | undefined {
  return useSelectedLocation()?.ascend_id ?? undefined;
}
